import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import CompLeaveRequest from '../components/CompLeaveRequest';
import NavBar from '../components/Menu/NavBar'
import { pageStyle } from '../components/UIComponent/CommonStyle'
import { setLocalStorageSettings } from '../components/Function/globalFunction';

const useStyles = makeStyles(() => ({
    ...pageStyle()
}));

export default function CompLeaveRequestPage() {
    const classes = useStyles();
    setLocalStorageSettings({
        'selectedIndex': 2,
        'isMyRequestOpen': 'false',
        'isApplicationOpen': 'true',
        'isLeaveApprovalOpen': 'false',
        'isHRAdminOpen': 'false'
    });

    return (
        <div className={classes.root}>
            <CssBaseline />
            <NavBar />
            <CompLeaveRequest />
        </div>
    )
}